import { render, staticRenderFns } from "./rustTaskDetail.vue?vue&type=template&id=553a97de&scoped=true&"
import script from "./rustTaskDetail.vue?vue&type=script&lang=js&"
export * from "./rustTaskDetail.vue?vue&type=script&lang=js&"
import style0 from "./rustTaskDetail.vue?vue&type=style&index=0&id=553a97de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553a97de",
  null
  
)

export default component.exports